import React, { useState } from 'react';
import { useTranslation } from '../../hooks/useTranslation';

interface DatePickerWithRangeProps {
  date: { from: Date | undefined; to: Date | undefined };
  onDateChange: (date: { from: Date | undefined; to: Date | undefined }) => void;
  className?: string;
}

export function DatePickerWithRange({ date, onDateChange, className }: DatePickerWithRangeProps) {
  const { t } = useTranslation();
  const [isOpen, setIsOpen] = useState(false);

  const formatDate = (date: Date) => {
    return date.toLocaleDateString('ru-RU');
  };

  const handleDateChange = (field: 'from' | 'to', value: string) => {
    const newDate = value ? new Date(value) : undefined;
    onDateChange({
      ...date,
      [field]: newDate
    });
  };

  return (
    <div className={`relative ${className}`}>
      <button
        type="button"
        onClick={() => setIsOpen(!isOpen)}
        className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent text-left"
      >
        {date.from ? (
          date.to ? (
            `${formatDate(date.from)} - ${formatDate(date.to)}`
          ) : (
            formatDate(date.from)
          )
        ) : (
          t('common.selectPeriod')
        )}
      </button>
      
      {isOpen && (
        <div className="absolute top-full left-0 right-0 mt-1 bg-white border border-gray-300 rounded-lg shadow-lg z-10 p-4">
          <div className="space-y-4">
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1">{t('common.from')}</label>
              <input
                type="date"
                value={date.from ? date.from.toISOString().split('T')[0] : ''}
                onChange={(e) => handleDateChange('from', e.target.value)}
                className="w-full px-3 py-2 border border-gray-300 rounded-md focus:ring-2 focus:ring-blue-500 focus:border-transparent"
              />
            </div>
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1">{t('common.to')}</label>
              <input
                type="date"
                value={date.to ? date.to.toISOString().split('T')[0] : ''}
                onChange={(e) => handleDateChange('to', e.target.value)}
                className="w-full px-3 py-2 border border-gray-300 rounded-md focus:ring-2 focus:ring-blue-500 focus:border-transparent"
              />
            </div>
            <div className="flex justify-end space-x-2">
              <button
                type="button"
                onClick={() => {
                  onDateChange({ from: undefined, to: undefined });
                  setIsOpen(false);
                }}
                className="px-3 py-1 text-sm text-gray-600 hover:text-gray-800"
              >
                {t('common.clear')}
              </button>
              <button
                type="button"
                onClick={() => setIsOpen(false)}
                className="px-3 py-1 text-sm bg-blue-600 text-white rounded hover:bg-blue-700"
              >
                {t('common.apply')}
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
